<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="xl" striped hover select-mode="multi" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-right head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template v-slot:cell(indicazioniSoggetto)="{ item }">{{ item.cognome }} {{ item.nome }}</template>
                        <template v-slot:cell(actions)="row">
                            <b-container class="bv-example-row">
                                <b-button v-b-tooltip.hover size="sm" variant="outline-primary" title="Dettaglio Soggetto" @click="onView(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="eye"></font-awesome-icon>
                                </b-button>
                                <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Soggetto" @click="onEdit(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Soggetto" @click="onDelete(row.item)" class="mr-1 no-text">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    data() {
        return {
            currentPage: 1,
            rows: 0,
            perPage: 50,
            pathResource: "/contabilitasoggetti",
            items: [],
            fields: [
                {
                    label: "N.",
                    key: "index",
                    thStyle: "width: 3rem",
                },
                {
                    label: "Nome e cognome",
                    key: "indicazioniSoggetto",
                },
                {
                    label: "Ragione Sociale Soggetto",
                    key: "ragioneSoggetto",
                    thStyle: "width: 8rem",
                },
                {
                    label: "Indirizzo ",
                    key: "indirizzoSoggetto",
                    thStyle: "width: 15rem",
                },
                {
                    label: "Partita Iva",
                    key: "pivaSoggetto",
                },
                {
                    label: "Codice Soggetto",
                    key: "codiceSoggetto",
                    // thStyle: "width: 14rem",
                },
                {
                    label: "Note Soggetto",
                    key: "noteSoggetto",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    methods: {
        refresh(filter) {
            let me = this;
            me.$emit("beforeLoadData");
            me.loadData(filter);
        },
        loadData(filtro) {
            let me = this;
            me.$emit("beforeLoadData");
            filtro.perPage = me.perPage;
            filtro.page = me.currentPage;
            filtro.page;
            UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            error;
            me.$emit("afterLoadData");
        },
        onEdit(item) {
            this.$router.push({
                name: "ContabilitaSoggettoEditPage",
                params: { id: item.id },
            });
        },
        onView(item) {
            this.$router.push({
                name: "ContabilitaSoggettoViewPage",
                params: { id: item.id },
            });
        },
        onDelete(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di voler cancellare questo soggetto?", {
                    title: "Conferma cancellazione",
                    size: "md",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Si",
                    cancelTitle: "No",
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.$emit("beforeLoadData");
                        UtilityMixin.methods.deleteResource(me.pathResource + "/" + item.id, me.loadDataDeleteSuccess, me.loadDataDeleteError);
                    }
                });
        },
        loadDataDeleteSuccess(response) {
            let me = this;
            let msg = response.data.message || "Soggetto cancellato con successo.";
            me.$bvToast.toast(msg, {
                title: "Cancellazione completata",
                variant: "success",
                solid: true,
            });
            me.loadData(me.filtroContabilitaSoggetto);
        },
        loadDataDeleteError(error) {
            let me = this;
            console.error("Errore durante la cancellazione del soggetto", error);
            me.$bvToast.toast("Si è verificato un errore durante la cancellazione del soggetto.", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>

<style></style>
